<template>
  <v-data-table :headers="headers" :items="listPiutang" class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Daftar Piutang</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
    </template>
    <template v-slot:item.total="{ item }">Rp. {{convertCurrency(item.total)}}</template>
    <template v-slot:item.piutang="{ item }">
      Rp.
      <span style="font-weight: bold;color: #43A047;">{{convertCurrency(item.piutang)}}</span>
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip small class="ma-2" label :color="statusColor[item.status]">{{ item.status}}</v-chip>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template>
    <template v-slot:no-data>
      <span class="text-center">No data available.</span>
    </template>
    <template v-slot:footer>
      <v-divider></v-divider>
      <div style="padding:0 5em;">
        <div :class="`d-flex justify-end`">
          <h5>Jumlah yang harus terbayarkan: 
            <span style="font-weight: bold;font-size: 1.5rem;color:#4e4e4e;">Rp. <span style="color: #43A047;">{{convertCurrency(totalPiutang)}}</span></span></h5>
        </div>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { slice, orderBy } from "lodash";
import { formatCurrency } from "@/libs/number";

export default {
  data: () => ({
    dialogEditRole: false,
    dialogAddRole: false,
    loading: false,
    headers: [
      {
        text: "Nama Penawaran",
        align: "left",
        sortable: false,
        value: "name"
      },
      { text: "Total Harga", value: "total" },
      { text: "Piutang", value: "piutang" },
      { text: "Status Penawaran", value: "status" }
    ],
    listPiutang: [],
    totalPiutang: 0,
    editedIndex: -1,
    defaultItem: {
      name: "",
      role: {
        id: ""
      }
    },
    statusColor: {
      DRAFT: "yellow",
      CANCELED: "red",
      REJECTED: "red",
      FAILED: "red",
      REFUNDED: "orange",
      PENDING: "secondary",
      PARTIAL: "default",
      PAID: "green lighten-1",
      APPROVED: "primary",
      COMPLETED: "success"
    }
  }),

  computed: {
    ...mapGetters({
      getRoles: "role_permission/getRoles",
      getPiutang: "utang_piutang/getPiutang"
    }),
    formTitle() {
      return this.editedIndex === -1 ? "Set Permission to Role" : "Edit Role";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    convertCurrency(total) {
      return formatCurrency(total);
    },
    async initialize() {
      this.listPiutang = await this.getPiutang;
      this.totalPiutang = this.listPiutang.reduce((acc, piutang) => {return acc + parseFloat(piutang.piutang)}, 0)
    },
    close() {
      this.dialogEditRole = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    }
  }
};
</script>